import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import Button from '../../../../../ui/canon/Button';
import { SendIcon } from 'lucide-react';

const DatePickerWidget = ({ onAnswer, disabled, initialValue = '' }) => {
  const intl = useIntl();
  const [date, setDate] = useState(initialValue || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setDate(initialValue || '');
    setIsSubmitting(false);
  }, [initialValue]);

  const handleSubmit = () => {
    if (date && !isSubmitting) {
      setIsSubmitting(true);
      onAnswer({ value: date });
    }
  };

  return (
    <div className="space-y-3">
      <input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        disabled={disabled || isSubmitting}
        className="w-full px-3 py-2 border border-succession-border rounded-md bg-succession-bg-primary text-succession-text-primary focus:outline-none focus:ring-2 focus:ring-succession-focus-ring"
      />
      <Button
        onClick={handleSubmit}
        disabled={!date || disabled || isSubmitting}
        className="w-full"
      >
        <SendIcon className="h-4 w-4 mr-2" />
        {intl.formatMessage({ id: 'succession.plans.widget_submit_answer' })}
      </Button>
    </div>
  );
};

export default DatePickerWidget;
